module.exports = __webpack_public_path__ + "static/media/tommy_keith_brewery_kiss.03d272cb.jpg";